var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "widthFull h-100 somatoline pb-5 back-1",
      attrs: { id: "top" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-5 pt-5" }, [
        _vm.contests.config
          ? _c("div", { staticClass: "col-12 center" }, [
              _c("img", {
                staticClass: "img img-fluid",
                attrs: { src: _vm.contests.config.LOGO_INTERNO }
              })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.empty && !_vm.notRegister
        ? _c(
            "div",
            { staticClass: "container", class: { "mt-5": _vm.vw > 700 } },
            [
              _c(
                "div",
                { staticClass: "back-white row justify-content-center mt-5" },
                [
                  _vm.vw > 700
                    ? _c("div", { staticClass: "col-10 Bold mb-3" }, [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "back-white color uppercase center padd"
                          },
                          [
                            _c("h5", [_vm._v("Promozione:")]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.contests.title) +
                                "\n        "
                            )
                          ]
                        )
                      ])
                    : _c("div", { staticClass: "col-12 Bold mb-3" }, [
                        _c("small", { staticClass: "color uppercase Bold" }, [
                          _vm._v("Promozione: ")
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "back-white black" }, [
                          _vm._v(_vm._s(_vm.contests.title))
                        ])
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-5 center",
                      class: { "pt-5": _vm.vw > 700 }
                    },
                    [
                      _c(
                        "form",
                        {
                          class: { "mt-2": _vm.vw > 700 },
                          attrs: {
                            id: "edit-user-form",
                            autocomplete: "qwerqrt"
                          },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.callOCR.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm.statusOCR != "OK"
                            ? _c(
                                "label",
                                {
                                  staticClass:
                                    "lable-style-custom h4 Bold uppercase",
                                  attrs: { for: "tappa" }
                                },
                                [_vm._v("Carica la foto dello scontrino:")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.statusOCR == "OK"
                            ? _c(
                                "label",
                                {
                                  staticClass:
                                    "lable-style-custom h4 Bold uppercase",
                                  attrs: { for: "tappa" }
                                },
                                [_vm._v("Premi sulla foto per ingrandirla")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row justify-content-center mb-5" },
                            [
                              _c(
                                "div",
                                {
                                  class: {
                                    "group front-image center mt-3 ": !_vm.invoiceFrontBucket,
                                    "group front-image-1 center mt-5":
                                      _vm.invoiceFrontBucket
                                  }
                                },
                                [
                                  !_vm.invoiceFrontBucket
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              size: 10240,
                                              ext: [
                                                "jpeg",
                                                "jpg",
                                                "png",
                                                "pdf"
                                              ],
                                              mimes: [
                                                "image/jpeg",
                                                "image/jpg",
                                                "image/png",
                                                "application/pdf"
                                              ]
                                            },
                                            expression:
                                              "{\n                  required: true,\n                  size: 10240,\n                  ext: ['jpeg', 'jpg', 'png', 'pdf'],\n                  mimes: [\n                    'image/jpeg',\n                    'image/jpg',\n                    'image/png',\n                    'application/pdf',\n                  ],\n                }"
                                          }
                                        ],
                                        ref: "invoice",
                                        staticClass: "fileInput",
                                        class: {
                                          "is-invalid": _vm.errors.has(
                                            "invoice"
                                          ),
                                          valid: !!_vm.invoiceFront,
                                          helper: !!_vm.invoiceFrontBucket
                                        },
                                        attrs: {
                                          type: "file",
                                          name: "invoice",
                                          id: "invoice",
                                          "data-vv-as": "Scontrino"
                                        },
                                        on: { change: _vm.uploadFile }
                                      })
                                    : _c("input", {
                                        attrs: { type: "file", disabled: "" }
                                      }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoice" }
                                    },
                                    [
                                      !_vm.invoiceFrontBucket
                                        ? _c("span", [_vm._v("Scegli")])
                                        : _vm.invoiceFrontBucket &&
                                          !_vm.invoiceFrontBucket
                                            .toUpperCase()
                                            .includes(".PDF")
                                        ? _c(
                                            "viewer",
                                            {
                                              staticClass:
                                                "images clearfix widthFull",
                                              on: { inited: _vm.inited }
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "img-fluid img-mod",
                                                staticStyle: {
                                                  "border-radius": "10px"
                                                },
                                                attrs: {
                                                  src: _vm.invoiceFrontBucket
                                                }
                                              })
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              ref: "inv",
                                              staticClass:
                                                "images clearfix widthFull"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "underline theme",
                                                  attrs: {
                                                    href:
                                                      _vm.invoiceFrontBucket,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Clicca qui per vedere il pdf"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.invoiceFrontBucket
                                        ? _c(
                                            "span",
                                            { staticClass: "Bold" },
                                            [
                                              _c("br"),
                                              _c("font-awesome-icon", {
                                                staticClass: "helper mr-1",
                                                attrs: {
                                                  icon: "check-circle",
                                                  size: "1x"
                                                }
                                              }),
                                              _vm._v("Scontrino caricato")
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoice")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback-1" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.errors.first("invoice")
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.mobileUpl && _vm.statusOCR != "OK" && _vm.contests.config
                    ? _c("div", { staticClass: "col-md-5 center pt-5 mt-5" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-center" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _vm.vw > 600
                              ? _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "mt-1 uppercase",
                                      on: {
                                        click: function($event) {
                                          return _vm.QRcode(
                                            _vm.token,
                                            _vm.userToken,
                                            _vm.piva
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img img-fluid",
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          src: require("../../assets/images/mobile.png")
                                        }
                                      }),
                                      _c("br"),
                                      _c(
                                        "small",
                                        { staticClass: "black Medium" },
                                        [_vm._v("Carica la foto da cellulare")]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.contests.config.HAS_WA
                              ? _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pt-1 uppercase",
                                      on: {
                                        click: function($event) {
                                          return _vm.waLog(
                                            _vm.token,
                                            _vm.userToken,
                                            _vm.contests
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img img-fluid mt-3 pt-1",
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          src: require("../../assets/images/wa.png")
                                        }
                                      }),
                                      _c("br"),
                                      _c(
                                        "small",
                                        { staticClass: "black Medium" },
                                        [_vm._v("Carica tramite whatsapp")]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.statusOCR == "OK"
                    ? _c(
                        "div",
                        {
                          staticClass: "col-md-6 mb-5 mt-md-5 pt-md-3 mb-lg-0"
                        },
                        [
                          _c(
                            "div",
                            {
                              style:
                                "background:" +
                                _vm.contests.config.COLORE_CHIARO +
                                "!important;border-radius:10px;padding:9px",
                              attrs: { id: "top" }
                            },
                            [
                              _c("h5", { staticClass: "uppercase mb-lg-3" }, [
                                _vm._v("Riepilogo scontrino caricato:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-lg-6 col-12 mb-4",
                                      class: {
                                        "closedBlock ": !!_vm.ocrData.numero
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "group" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.number,
                                              expression: "number"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                integer: true,
                                                is_not: 0
                                              },
                                              expression:
                                                "{\n                    required: true,\n                    integer: true,\n                    is_not: 0,\n                  }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "number"
                                            ),
                                            valid: !!_vm.number,
                                            "form-control-dis": !!_vm.ocrData
                                              .numero
                                          },
                                          attrs: {
                                            type: "number",
                                            disabled: !!_vm.ocrData.numero,
                                            id: "number",
                                            name: "number",
                                            "data-vv-as": "Numero"
                                          },
                                          domProps: { value: _vm.number },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.number = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "lable-style",
                                            attrs: { for: "number" }
                                          },
                                          [
                                            _vm._v(
                                              "Numero scontrino\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("number")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.errors.first("number")
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-6 col-12 mb-5 mb-md-0",
                                      class: {
                                        "closedBlock ": !!_vm.ocrData.importo
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "group priceVal pr-0 mr-0"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.price,
                                                expression: "price"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  regex: /^([0-9][0-9]*)$/,
                                                  max: 4
                                                },
                                                expression:
                                                  "{\n                    required: true,\n                    regex: /^([0-9][0-9]*)$/,\n                    max: 4,\n                  }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "price"
                                              ),
                                              valid: !!_vm.price,
                                              "form-control-dis": !!_vm.ocrData
                                                .importo
                                            },
                                            attrs: {
                                              type: "text",
                                              disabled: !!_vm.ocrData.importo,
                                              id: "price",
                                              name: "price",
                                              "data-vv-as": "Importo Euro"
                                            },
                                            domProps: { value: _vm.price },
                                            on: {
                                              focus: function($event) {
                                                _vm.priceFocused = true
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.price = $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.priceFocused ||
                                          _vm.priceCent ||
                                          _vm.price
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pseudoEuro theme"
                                                },
                                                [_vm._v("€")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "highlight"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "bar" }),
                                          _vm._v(" "),
                                          !_vm.priceCent ||
                                          (_vm.priceCent && _vm.price)
                                            ? _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "lable-style newPriceLabel doubleRow",
                                                  attrs: { for: "price" }
                                                },
                                                [_vm._v("Importo tot*")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.errors.has("price")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "invalid-feedback",
                                                  staticStyle: {
                                                    width: "200%",
                                                    display: "block",
                                                    position: "absolute"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "price"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "theme" }, [
                                        _vm._v(",")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "group priceCent pl-0 ml-0"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.priceCent,
                                                expression: "priceCent"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  min: 2,
                                                  max: 2,
                                                  regex: /^([0-9]+)$/
                                                },
                                                expression:
                                                  "{\n                    required: true,\n                    min: 2,\n                    max: 2,\n                    regex: /^([0-9]+)$/,\n                  }"
                                              }
                                            ],
                                            staticClass:
                                              "form-control text-left centInput",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "priceCent"
                                              ),
                                              valid: !!_vm.priceCent,
                                              "form-control-dis": !!_vm.ocrData
                                                .importo
                                            },
                                            attrs: {
                                              type: "text",
                                              disabled: !!_vm.ocrData.importo,
                                              id: "priceCent",
                                              name: "priceCent",
                                              "data-vv-as": "Centesimi"
                                            },
                                            domProps: { value: _vm.priceCent },
                                            on: {
                                              focus: function($event) {
                                                _vm.priceFocused = true
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.priceCent =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.priceFocused ||
                                          _vm.priceCent ||
                                          _vm.price
                                            ? _c(
                                                "span",
                                                { staticClass: "pseudoCent" },
                                                [_vm._v("Cent.")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "highlight"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "bar" }),
                                          _vm._v(" "),
                                          !_vm.price && _vm.priceCent
                                            ? _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "niceInputLabel newPriceLabel",
                                                  staticStyle: {
                                                    "margin-left": "-115%"
                                                  },
                                                  attrs: { for: "price" }
                                                },
                                                [_vm._v("Importo")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.errors.has("priceCent") &&
                                          !_vm.errors.has("price")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "invalid-feedback",
                                                  staticStyle: {
                                                    width: "200%",
                                                    display: "block",
                                                    position: "absolute",
                                                    "margin-left": "-100%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "priceCent"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-6 col-12 mb-3 mb-md-0",
                                      class: {
                                        "closedBlock ": !!_vm.ocrData.ora
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "group" },
                                        [
                                          _c("vue-timepicker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  emptyTime: true
                                                },
                                                expression:
                                                  "{ required: true, emptyTime: true }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              disabledTime:
                                                !!_vm.time.HH && !!_vm.time.mm,
                                              "is-invalid": _vm.errors.has(
                                                "time"
                                              ),
                                              valid: !!_vm.time.HH != "",
                                              "time-picker-dis ": !!_vm.ocrData
                                                .ora
                                            },
                                            attrs: {
                                              disabled: !!_vm.ocrData.ora,
                                              hideClearButton: true,
                                              "data-vv-validate-on": "none",
                                              id: "time",
                                              name: "time",
                                              "data-vv-as": "Ora Scontrino"
                                            },
                                            model: {
                                              value: _vm.time,
                                              callback: function($$v) {
                                                _vm.time = $$v
                                              },
                                              expression: "time"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "highlight"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "bar" }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "lable-style labelTime",
                                              attrs: { for: "time" }
                                            },
                                            [_vm._v("Ora scontrino")]
                                          ),
                                          _vm._v(" "),
                                          _vm.errors.has("time")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "invalid-feedback"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.errors.first("time")
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-lg-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mb-3 mb-md-0",
                                        class: {
                                          "closedBlock ": !!_vm.ocrData.data
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "group" },
                                          [
                                            _c("datepicker", {
                                              attrs: {
                                                language: _vm.it,
                                                disabled: !!_vm.ocrData.data,
                                                "full-month-name": true,
                                                initialView: "month",
                                                format: "dd MMMM yyyy",
                                                "monday-first": true,
                                                disabledDates:
                                                  _vm.disabledDates,
                                                id: "date",
                                                name: "date",
                                                "input-class": "form-control "
                                              },
                                              model: {
                                                value: _vm.date,
                                                callback: function($$v) {
                                                  _vm.date = $$v
                                                },
                                                expression: "date"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: false,
                                                  expression: "false"
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.date,
                                                  expression: "date"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: { required: true },
                                                  expression:
                                                    "{ required: true }"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              class: {
                                                "is-invalid": _vm.errors.has(
                                                  "date"
                                                ),
                                                valid: !!_vm.date,
                                                "form-control-dis": !!_vm
                                                  .ocrData.data
                                              },
                                              attrs: {
                                                type: "text",
                                                id: "date",
                                                name: "date",
                                                "data-vv-as": "Data scontrino"
                                              },
                                              domProps: { value: _vm.date },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.date = $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "lable-style",
                                                attrs: { for: "date" }
                                              },
                                              [_vm._v("Data scontrino")]
                                            ),
                                            _vm._v(" "),
                                            _vm.errors.has("date")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "date"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm.empty
        ? _c("div", { staticClass: "container-fluid mt-5 pt-5" }, [_vm._m(1)])
        : _vm.notRegister
        ? _c("div", { staticClass: "container-fluid mt-5 pt-5" }, [_vm._m(2)])
        : _vm._e(),
      _vm._v(" "),
      _vm.statusOCR == "OK"
        ? _c(
            "div",
            { staticClass: "container back-white" },
            [
              _c("STEP2PRODOTTI", {
                attrs: {
                  date_sc: _vm.date,
                  time_sc: _vm.time,
                  price_sc: _vm.price,
                  priceCent_sc: _vm.priceCent,
                  number_sc: _vm.number,
                  immagine_sc: _vm.invoiceFrontBucket,
                  ocrContent: _vm.saveDataOcr,
                  erroriOcr: _vm.ocrErrors
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "mt-4 color Medium h2" }, [_vm._v("Oppure:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "row justify-content-center mt-5 pt-5 back-white" },
      [
        _c("div", { staticClass: "col-md-10 center mt-5 pt-5 pb-5 mb-5" }, [
          _c("h1", [
            _vm._v(
              "\n          LA PROMOZIONE CHE STAI CERCANDO NON É ANCORA ATTIVA OPPURE É GIÁ\n          TERMINATA\n        "
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "row justify-content-center mt-5 pt-5 back-white" },
      [
        _c("div", { staticClass: "col-md-10 center mt-5 pt-5 pb-5 mb-5" }, [
          _c("h1")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f59cc7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f59cc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/play/index.vue
// module id = null
// module chunks = 